import api from '@/api/index'
import common from '@/components'

const state = {
    //我的待审
    common_data:{
        page:1,
        limit:50,
        check_status:0
    },
}

const mutations = {
    set_common_data(state,val){
        state.common_data = val
    }
}

const actions = {
    //渠道分发 审核列表
    review_list({commit, dispatch, state, rootState}, parasm = {}) {
        let data = {
            access_token:localStorage.getItem("access_token"),
            page:state.common_data.page,
            limit:state.common_data.limit,
            check_status:state.common_data.check_status,
            type:10
        }
        api.review_list(data).then(res => {
            parasm.scCallback && parasm.scCallback(res);
        }).catch(res => {
        })
    }
}

const getters = {
    // type_list(){
    //     return state.type_list
    // }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
